<template>
  <div class="selector-site-obj-">
    <multiselect
      v-model="selected"
      @input="onChange"
      :options="options"
      :custom-label="labelSite"
      :multiple="isMulti == true ? true : false"
      selectLabel=""
      selectedLabel="«"
      deselectLabel=""
      :allowEmpty="allowEmpty"
      :preselectFirst="true"
      :loading="isLoading"
      :label="$t('Nome')"
      track-by="id"
      :disabled="isDisabled"
      placeholder=""
      :required="isRequired"
    >
      <template slot="noResult">
        <span>{{ $t('Nenhum elemento encontrado') }}.</span>
      </template>
      <template slot="noOptions">
        <span>{{ $t('Nenhum dado foi retornado') }}.</span>
      </template>
      <template slot="placeholder">
        <span>{{ $t(emptyLabel) }}</span>
      </template>
    </multiselect>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'isMulti',
    'alreadySelected',
    'allowEmpty'
  ],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'site', null);
        return;
      }
      this.$emit('selectChange', 'site', e);
      this.$emit('focus');
    },
    labelSite({ nome_fantasia }) {
      return nome_fantasia;
    },
    setValue(value) {
      if (this.alreadySelected && this.alreadySelected.length && this.isMulti) {
        this.selected = this.options.filter((option) => this.alreadySelected.includes(option.id));
      } else if (value) {
        if (typeof value == 'number') {
          this.selected = this.options.find((option) => option.id === value);
        } else {
          this.selected = this.options.find((option) => option.id === value.id);
        }
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      const sites = this.$store.state.user.info.hasOwnProperty('sites') ? this.$store.state.user.info.sites : null;
      this.isLoading = true;
      let filter = `id_empresa=${this.$store.state.user.info.id_empresa}`;

      if (sites != null && sites != '[]' && sites != ' ' && sites != '') {
        filter += ` and business_logic.localidade_web.id in (${sites})`;
      }
      this.$atenaList
        .getSites({
          columns: 'id,domain_id,id_localidade,id_localidades,nome_fantasia',
          filter: filter,
          order: 'id'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome_fantasia: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);

          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  }
};
</script>

<style lang="scss">
.selector-site-obj- {
  .multiselect:not(.multiselect--active) {
    .multiselect__tags {
      display: flex !important;
    }
  }
  .multiselect__tag {
    background: #26b4ff;
  }
}
</style>
